/* EOS Plates — fitment finder & garage  v3.0 (live)
   ---------------------------------------------------------------------------
   LIVE MODE  : reads Shopify storefront filters through /collections/all?view=eos-json
                so new products appear the moment their fitment metafields are set.
                Requires the "Vehicle brand" + "Vehicle year" filters to exist in
                Search & Discovery.
   STATIC MODE: falls back to window.EOS_FIT (assets/eos-fitment-data.js) if the
                endpoint is missing or errors, so the finder never breaks.
   Storage    : eos_garage = {"y":2021,"mk":"BMW","md":"M4"}
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var KEY = 'eos_garage', OPEN = 2099, RENDER_SEQ = 0;
  var ENDPOINT = '/collections/all?view=eos-json';
  var P_YEAR = 'filter.p.m.fitment.years';
  var P_MAKE = 'filter.p.m.fitment.make';
  var DATA = window.EOS_FIT || [];
  var MODE = 'static';
  var BOOT = null;                 // 開機時攞到嘅 filter 值
  var CACHE = {};                  // url -> payload
  var PRODUCTS = {};               // "year|make" -> products[]

  /* ---------------- storage ---------------- */
  function get() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return (v && v.y && v.mk && v.md) ? v : null; }
    catch (e) { return null; }
  }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function label(g) { return g ? g.y + ' ' + g.mk + ' ' + g.md : ''; }

  /* ---------------- live fetch ---------------- */
  function pull(url) {
    if (CACHE[url]) return Promise.resolve(CACHE[url]);
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.ok) { CACHE[url] = j; return j; }
        return null;
      })
      .catch(function () { return null; });
  }
  function filterOf(payload, param) {
    if (!payload || !payload.filters) return null;
    for (var i = 0; i < payload.filters.length; i++)
      if (payload.filters[i].param === param) return payload.filters[i];
    return null;
  }
  function urlFor(year, make) {
    var u = ENDPOINT;
    if (year) u += '&' + P_YEAR + '=' + encodeURIComponent(year);
    if (make) u += '&' + P_MAKE + '=' + encodeURIComponent(make);
    return u;
  }

  /* ---------------- static helpers ---------------- */
  function sYears() {
    var max = 0, min = 9999, i;
    for (i = 0; i < DATA.length; i++) {
      if (DATA[i][0] < min) min = DATA[i][0];
      if (DATA[i][1] !== OPEN && DATA[i][1] > max) max = DATA[i][1];
    }
    if (!DATA.length) return [];
    var top = Math.max(max, new Date().getFullYear() + 1), out = [];
    for (var y = top; y >= min; y--) out.push(String(y));
    return out;
  }
  function sMakes(y) {
    var s = {}, i; y = +y;
    for (i = 0; i < DATA.length; i++) if (y >= DATA[i][0] && y <= DATA[i][1]) s[DATA[i][2]] = 1;
    return Object.keys(s).sort();
  }
  function sModels(y, mk) {
    var s = {}, i; y = +y;
    for (i = 0; i < DATA.length; i++)
      if (DATA[i][2] === mk && y >= DATA[i][0] && y <= DATA[i][1]) s[DATA[i][3]] = 1;
    return Object.keys(s).sort(cmp);
  }
  function cmp(a, b) { return String(a).localeCompare(String(b), undefined, { numeric: true }); }

  /* ---------------- unified async API ---------------- */
  function getYears() {
    if (MODE === 'live') {
      var f = filterOf(BOOT, P_YEAR);
      var out = f ? f.values.map(function (v) { return v.v; }) : [];
      out.sort(function (a, b) { return (+b) - (+a); });
      return Promise.resolve(out);
    }
    return Promise.resolve(sYears());
  }
  function getMakes(year) {
    if (MODE === 'live') {
      return pull(urlFor(year, null)).then(function (j) {
        var f = filterOf(j, P_MAKE);
        return f ? f.values.map(function (v) { return v.v; }).sort(cmp) : [];
      });
    }
    return Promise.resolve(sMakes(year));
  }
  function getProducts(year, make) {
    var k = year + '|' + make;
    if (PRODUCTS[k]) return Promise.resolve(PRODUCTS[k]);
    if (MODE === 'live') {
      return pull(urlFor(year, make)).then(function (j) {
        var list = (j && j.products) || [];
        PRODUCTS[k] = list;
        return list;
      });
    }
    return Promise.resolve([]);
  }
  function getModels(year, make) {
    if (MODE === 'live') {
      return getProducts(year, make).then(function (list) {
        var s = {}, i, parts, j;
        for (i = 0; i < list.length; i++) {
          parts = String(list[i].m || '').split('/');
          for (j = 0; j < parts.length; j++) {
            var t = parts[j].trim();
            if (t) s[t] = 1;
          }
        }
        return Object.keys(s).sort(cmp);
      });
    }
    return Promise.resolve(sModels(year, make));
  }
  /* 揀齊三樣之後，攞返實際啱嘅產品 */
  function getMatches(g) {
    if (!g) return Promise.resolve([]);
    if (MODE === 'live') {
      return getProducts(g.y, g.mk).then(function (list) {
        return list.filter(function (p) {
          var parts = String(p.m || '').split('/');
          for (var i = 0; i < parts.length; i++) if (parts[i].trim() === g.md) return true;
          return false;
        });
      });
    }
    var out = [], seen = {}, i, e;
    for (i = 0; i < DATA.length; i++) {
      e = DATA[i];
      if (e[2] === g.mk && e[3] === g.md && g.y >= e[0] && g.y <= e[1] && !seen[e[5]]) {
        seen[e[5]] = 1;
        out.push({ h: e[5], t: '', m: e[3], price: null, varies: false, img: '', _static: true });
      }
    }
    return Promise.resolve(out);
  }

  /* ---------------- fit check ---------------- */
  function fitsProduct(g, box) {
    if (!g) return null;
    var mk = box.getAttribute('data-eos-make') || '';
    var md = box.getAttribute('data-eos-model') || '';
    var ys = box.getAttribute('data-eos-years') || '';
    if (mk) {                                   // metafield 有值 -> 用真數據
      if (mk !== g.mk) return false;
      if (md) {
        var ok = false, parts = md.split('/');
        for (var i = 0; i < parts.length; i++) if (parts[i].trim() === g.md) ok = true;
        if (!ok) return false;
      }
      if (ys) return ys.split(',').map(function (s) { return s.trim(); }).indexOf(String(g.y)) !== -1;
      return true;
    }
    // 冇 metafield -> 用返靜態表
    var h = box.getAttribute('data-eos-handle'), e = [], j;
    for (j = 0; j < DATA.length; j++) if (DATA[j][5] === h) e.push(DATA[j]);
    if (!e.length) return null;
    for (j = 0; j < e.length; j++)
      if (e[j][2] === g.mk && e[j][3] === g.md && g.y >= e[j][0] && g.y <= e[j][1]) return true;
    return false;
  }
  function coversText(box) {
    var mk = box.getAttribute('data-eos-make') || '';
    var md = box.getAttribute('data-eos-model') || '';
    var ys = (box.getAttribute('data-eos-years') || '').split(',').filter(Boolean);
    if (mk) {
      var yr = ys.length ? ys[0].trim() + '-' + ys[ys.length - 1].trim() + ' ' : '';
      return (yr + mk + ' ' + md).trim();
    }
    var h = box.getAttribute('data-eos-handle'), s = [], i;
    for (i = 0; i < DATA.length; i++)
      if (DATA[i][5] === h)
        s.push(DATA[i][0] + '-' + (DATA[i][1] === OPEN ? 'Up' : DATA[i][1]) + ' ' + DATA[i][2] + ' ' + DATA[i][3]);
    return s.join(', ');
  }

  /* ---------------- select wiring ---------------- */
  function fill(sel, arr, ph) {
    var h = '<option value="">' + ph + '</option>', i;
    for (i = 0; i < arr.length; i++) h += '<option value="' + arr[i] + '">' + arr[i] + '</option>';
    sel.innerHTML = h;
  }
  function busy(sel, on, ph) {
    sel.disabled = true;
    if (on) sel.innerHTML = '<option value="">' + (ph || 'Loading…') + '</option>';
  }

  function wire(root, onReady) {
    var yS = root.querySelector('[data-eos-year]'),
        mS = root.querySelector('[data-eos-make]'),
        dS = root.querySelector('[data-eos-model]'),
        go = root.querySelector('[data-eos-go]');
    if (!yS || !mS || !dS) return;

    function state() {
      var ok = yS.value && mS.value && dS.value;
      if (go) go.disabled = !ok;
      return ok;
    }

    getYears().then(function (ys) { fill(yS, ys, 'Year'); restore(); });

    yS.addEventListener('change', function () {
      fill(dS, [], 'Model'); dS.disabled = true;
      if (!yS.value) { fill(mS, [], 'Make'); mS.disabled = true; state(); return; }
      busy(mS, true);
      getMakes(yS.value).then(function (mk) {
        fill(mS, mk, 'Make'); mS.disabled = false; state();
      });
    });

    mS.addEventListener('change', function () {
      if (!mS.value) { fill(dS, [], 'Model'); dS.disabled = true; state(); return; }
      busy(dS, true);
      getModels(yS.value, mS.value).then(function (md) {
        fill(dS, md, 'Model'); dS.disabled = false; state();
      });
    });

    dS.addEventListener('change', state);

    function restore() {
      var g = get();
      if (!g) { state(); return; }
      yS.value = g.y;
      if (!yS.value) { state(); return; }
      busy(mS, true);
      getMakes(g.y).then(function (mk) {
        fill(mS, mk, 'Make'); mS.disabled = false; mS.value = g.mk;
        if (!mS.value) { state(); return; }
        busy(dS, true);
        return getModels(g.y, g.mk).then(function (md) {
          fill(dS, md, 'Model'); dS.disabled = false; dS.value = g.md; state();
        });
      });
    }

    if (go) go.addEventListener('click', function () {
      if (!state()) return;
      var v = { y: +yS.value, mk: mS.value, md: dS.value };
      set(v); paintGarage();
      if (onReady) onReady(v, root);
    });
  }

  /* ---------------- results ---------------- */
  function money(c) {
    if (c === null || c === undefined) return '';
    try {
      return (c / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function render(box, g, jump) {
    var seq = ++RENDER_SEQ;
    box.innerHTML = '<h3>Checking your ' + esc(label(g)) + ' <span class="eos-spin"></span></h3>' +
                    '<div class="eos-cards"><div class="eos-slot"></div></div>';

    getMatches(g).then(function (list) {
      if (seq !== RENDER_SEQ) return;

      if (!list.length) {
        box.innerHTML = '<div class="eos-empty"><b>We don\'t have a bracket listed for the ' +
          esc(label(g)) + ' yet.</b><br>Tell us and we\'ll check — most requests come back within 48 hours. ' +
          '<a class="eos-link" href="/pages/contact">Request this fitment &rarr;</a></div>';
        return;
      }
      if (jump && list.length === 1) { window.location.href = '/products/' + list[0].h; return; }

      var wide = list.length <= 2;
      box.innerHTML = '<h3>Fits your ' + esc(label(g)) + '</h3>' +
        '<div class="eos-cards' + (wide ? ' eos-cards--wide' : '') + '"></div>';
      var grid = box.querySelector('.eos-cards');

      list.forEach(function (p) {
        if (p._static) { hydrate(grid, p, g, wide, seq); return; }
        grid.appendChild(card(p, g, wide));
      });
    });
  }

  function card(p, g, wide) {
    var a = document.createElement('a');
    a.className = 'eos-card';
    a.href = '/products/' + p.h;
    a.innerHTML =
      (p.img ? '<span class="eos-cimg"><img loading="lazy" src="' + p.img + '" alt="' + esc(p.t) +
               '" width="600" height="600"></span>' : '') +
      '<span class="eos-cb"><span class="eos-badge">Fits your car</span>' +
      '<span class="eos-ct">' + esc(p.t) + '</span>' +
      (wide ? '<span class="eos-cd">' + esc(label(g)) +
              ' &middot; no drilling &middot; ships today</span>' : '') +
      '<span class="eos-crow"><span class="eos-cp">' +
      (p.price === null ? '' : (p.varies ? 'from ' : '') + money(p.price)) + '</span>' +
      (wide ? '<span class="eos-cgo">View product &rarr;</span>' : '') + '</span></span>';
    return a;
  }

  /* 靜態 fallback 冇 title/價錢 -> 補一次 product.js */
  function hydrate(grid, p, g, wide, seq) {
    var slot = document.createElement('div');
    slot.className = 'eos-slot';
    grid.appendChild(slot);
    fetch('/products/' + p.h + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (seq !== RENDER_SEQ) return;
        if (!j) { slot.remove(); return; }
        slot.replaceWith(card({
          h: j.handle, t: j.title, price: j.price, varies: j.price_varies,
          img: j.featured_image ? j.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : ''
        }, g, wide));
      })
      .catch(function () { if (seq === RENDER_SEQ) slot.remove(); });
  }

  /* ---------------- garage bar ---------------- */
  function paintGarage() {
    var g = get();
    document.querySelectorAll('[data-eos-garage]').forEach(function (bar) {
      var chip = bar.querySelector('[data-eos-chip]');
      if (chip) {
        chip.className = 'eos-chip' + (g ? '' : ' is-empty');
        chip.innerHTML = '<span class="eos-dot" aria-hidden="true"></span>' +
          '<span class="eos-lbl">Garage</span><span>' + (g ? esc(label(g)) : 'No vehicle selected') + '</span>';
      }
      var btn = bar.querySelector('[data-eos-change]');
      if (btn) btn.textContent = g ? 'Change vehicle' : 'Select your vehicle';
      var cl = bar.querySelector('[data-eos-clear]');
      if (cl) cl.hidden = !g;
    });
    document.querySelectorAll('[data-eos-fitcheck]').forEach(paintFit);
  }

  function paintFit(box) {
    var g = get(), v = fitsProduct(g, box), covers = coversText(box);
    if (!g) {
      box.className = 'eos-fit eos-fit--ask';
      box.innerHTML = '<span class="eos-ic" aria-hidden="true">&#128663;</span><div><b>Will this fit my car?</b>' +
        (covers ? 'This bracket is made for the ' + esc(covers) + '. ' : '') +
        '<button type="button" class="eos-link" data-eos-change>Select your vehicle to confirm</button></div>';
    } else if (v === true) {
      box.className = 'eos-fit eos-fit--yes';
      box.innerHTML = '<span class="eos-ic" aria-hidden="true">&#9989;</span><div><b>Confirmed fit &mdash; ' +
        esc(label(g)) + '</b>Bolts to your factory tow hook thread. No drilling.</div>';
    } else if (v === false) {
      box.className = 'eos-fit eos-fit--no';
      box.innerHTML = '<span class="eos-ic" aria-hidden="true">&#9888;</span><div><b>This one is not for your ' +
        esc(label(g)) + '</b>' + (covers ? 'It fits the ' + esc(covers) + '. ' : '') +
        '<button type="button" class="eos-link" data-eos-change>Find the bracket for my car</button></div>';
    } else {
      box.className = 'eos-fit eos-fit--ask';
      box.innerHTML = '<span class="eos-ic" aria-hidden="true">&#128663;</span><div><b>Fitment not listed for this product</b>' +
        'Check the title, or <a class="eos-link" href="/pages/contact">ask us</a> before you order.</div>';
    }
  }

  /* ---------------- modal ---------------- */
  var modal;
  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var f = modal.querySelector('[data-eos-year]'); if (f) f.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---------------- init ---------------- */
  function flash(box) {
    box.classList.remove('eos-flash');
    void box.offsetWidth;
    box.classList.add('eos-flash');
  }

  function start() {
    modal = document.querySelector('[data-eos-modal]');
    if (modal) {
      wire(modal, function (g) {
        closeModal();
        var finder = document.querySelector('[data-eos-finder]');
        if (finder) {
          var box = finder.querySelector('[data-eos-results]');
          if (box) { render(box, g, false); flash(box); finder.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          return;
        }
        if (!/\/products\//.test(location.pathname)) {
          getMatches(g).then(function (l) { if (l.length === 1) window.location.href = '/products/' + l[0].h; });
        }
      });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      var x = modal.querySelector('[data-eos-close]');
      if (x) x.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-eos-change]') : null;
      if (t) { e.preventDefault(); openModal(); return; }
      var c = e.target.closest ? e.target.closest('[data-eos-clear]') : null;
      if (c) {
        e.preventDefault(); clear(); paintGarage();
        document.querySelectorAll('[data-eos-results]').forEach(function (b) { b.innerHTML = ''; });
      }
    });

    document.querySelectorAll('[data-eos-finder]').forEach(function (root) {
      root.setAttribute('data-eos-mode', MODE);
      wire(root, function (g) {
        var box = root.querySelector('[data-eos-results]');
        if (!box) return;
        render(box, g, root.hasAttribute('data-eos-jump'));
        flash(box);
        if (box.getBoundingClientRect().bottom > window.innerHeight)
          box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      var g = get(), box = root.querySelector('[data-eos-results]');
      if (g && box && root.hasAttribute('data-eos-auto')) render(box, g, false);
    });

    paintGarage();
  }

  /* 開機：試 live，唔得就跌返靜態 */
  function boot() {
    pull(ENDPOINT).then(function (j) {
      var f = filterOf(j, P_YEAR);
      if (f && f.values && f.values.length) { MODE = 'live'; BOOT = j; }
      else if (!DATA.length) { MODE = 'live'; BOOT = j || { filters: [] }; }
      start();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.EOSGarage = {
    get: get, set: set, clear: clear, open: openModal,
    mode: function () { return MODE; }, matches: getMatches
  };
})();
